module.exports = __webpack_public_path__ + "static/logo-littlespoon@2x-ce21f3b90a01a75658039813bb76432d.png";